import React, { useEffect, useState } from "react";
import IndividualGrid from "../../../Components/IndividualGrid";
import CompanyGrid from "../../../Components/CompanyGrid";
import ApiRequest from "../../../Common/restservice";
import emptycart from "../../../Assets/Images/cart.png";
import { errorToast } from "../../../Common/showtoast";
import { useNavigate } from "react-router-dom";
import ContactGrid from "../../../Components/ContactGrid";

function Wishlist() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [pageno, setpageno] = useState(1);
  useEffect(() => {
    GetContacted();
  }, []);
  const GetContacted = async () => {
    let res = await ApiRequest(
      "GetWishList.asp",
      "POST",
      JSON.stringify({ pageno: pageno }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      setData([]);
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        navigate("/");
      }
      return;
    }
    setData(res.items);
  };
  return (
    <>
      <div className="row">
        {data.length <= 0 && (
          <div className="col-lg-12 col-md-12 col-xl-12">
            <div className="overflow-hidden">
              <div class="text-dark text-center">
                <div class="iteam-all-icon">
                  <img
                    src={emptycart}
                    class="imag-service"
                    alt="No records"
                    style={{ maxHeight: 200 }}
                  />
                </div>
                <div class="item-all-text mt-5">
                  <h5 class="text-body font-weight-bold">No Records Found</h5>
                </div>
              </div>
            </div>
          </div>
        )}
        {data.length > 0 && (
          <div className="tab-pane active table-responsive userprof-tab">
            <table className="table table-bordered table-hover mb-0 text-nowrap">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Item</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => {
                  return (
                    <ContactGrid
                      item={item}
                      index={index}
                      key={item.viewedmemberid}
                      nomobile={true}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <div class="center-block text-center">
        <ul class="pagination mb-5">
          <li
            class={`page-item page-prev ${pageno > 1 ? "" : "disabled"}`}
            onClick={() => {
              if (pageno > 1) setpageno(pageno - 1);
            }}
          >
            <label class="page-link">Prev</label>
          </li>

          <li
            class={`page-item page-prev ${
              data.length === 10 ? "" : "disabled"
            }`}
            onClick={() => {
              if (data.length === 10) setpageno(pageno + 1);
            }}
          >
            <label class="page-link">Next</label>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Wishlist;
